module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (136).0a0d9927.jpg";